import { render, staticRenderFns } from "./pay_former.vue?vue&type=template&id=13e0ff78&"
import script from "./pay_former.vue?vue&type=script&lang=js&"
export * from "./pay_former.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports